// extracted by mini-css-extract-plugin
export var author = "blog-post-preview-module--author--frAee";
export var avatar = "blog-post-preview-module--avatar--bVg80";
export var background = "blog-post-preview-module--background--Or51p";
export var blogpost = "blog-post-preview-module--blogpost--DM1Vm";
export var name = "blog-post-preview-module--name--E7ioD";
export var readingTime = "blog-post-preview-module--reading-time--An+yZ";
export var title = "blog-post-preview-module--title--hdrNs";